import east from './昭和基地東部地区.js'
import west from './昭和基地西部地区.js'
import shirase from './しらせ船内.js'

import route from './通路棟・防火区画.js'
//import base from './基本観測棟.js'
import base1 from './基本観測棟1F.js'
import base2 from './基本観測棟2F.js'
//import management from './管理棟.js'
import management1 from './管理棟1F.js'
import management2 from './管理棟2F.js'
import management3 from './管理棟3F.js'
import generator from './発電棟.js'
import warehouse from './倉庫棟.js'
import observatory from './観測棟.js'

import dataProcessing from './情報処理棟.js'
import optical from './光学観測棟.js'
import redome from './多目的アンテナレドーム.js'
import geology from './地学棟.js'
import quake from './地震計室.js'
import gravity from './重力計室.js'
import plasma from './電離層棟.js'
import nature from './自然エネルギー棟.js'
import satellite from './衛星受信棟.js'
import freshAir from './清浄大気観測小屋.js'
import intelsatredome from './インテルサットレドーム.js'
import release from './旧放球棟.js'
import duplicate from './duplicate.js'

export default [
  ...east,
  ...west,
  ...shirase,

  ...route,
//  ...base,
  ...base1,
  ...base2,
  ...management1,
  ...management2,
  ...management3,
  ...geology,
  ...warehouse,
  ...observatory,

  ...dataProcessing,
  ...optical,
  ...redome,
  ...generator,
  ...quake,
  ...gravity,
  ...plasma,
  ...nature,
  ...satellite,
  ...freshAir,
  ...intelsatredome,
  ...release,

  ...duplicate,
]
